import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Modal from "react-responsive-modal";
import Button from "../../common/button/button";
import EntityDetail from "../../common/entityDetail/entityDetail";
import LabelWithHR from "../../common/labels/labelWithHR";
import { newModalStyle } from "../../reusable/styles";
import Style from "./modalEditTicket.module.css";
import {formatCurrencyCode} from "../../utils/formatter";


const DriveOffDetailsModal = ({ open, close, onSave, countryCode, initialData = {} }) => {
  const { t } = useTranslation();
  const { register, handleSubmit, watch, reset, setValue } = useForm({
    defaultValues: {
      fuel: initialData?.fuel || "",
      fuelVolume: initialData?.fuelVolume || "",
      pillar: initialData?.pillar || "",
      amount: initialData?.amount || "",
      billRefNumber: initialData?.billRefNumber || ""
    }
  });

  useEffect(() => {
    reset({
      fuel: initialData?.fuel || "",
      fuelVolume: initialData?.fuelVolume || "",
      pillar: initialData?.pillar || "",
      amount: initialData?.amount || "",
      billRefNumber: initialData?.billRefNumber || ""
    });
  }, [initialData, reset]);

  const fuelWatch = watch("fuel");
  const fuelVolumeWatch = watch("fuelVolume");
  const pillarWatch = watch("pillar");
  const amountWatch = watch("amount");
  const billRefNumberWatch = watch("billRefNumber");

  const currencyDisplay = formatCurrencyCode(countryCode);


  const handleSaveForm = (data) => {
    onSave(data);
    close();
  };

  return (
    <Modal
      open={open}
      closeOnEsc
      onClose={close}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <form onSubmit={handleSubmit(handleSaveForm)}>
        <div className="modal__title">{t("DriveOffDetails.Title")}</div>

        <div>
          <LabelWithHR label={t("DriveOffDetails.Fuel")} />
          <input
            className={Style.textStyleInputEditModal}
            {...register("fuel")}
          />
        </div>

        <div>
          <LabelWithHR label={t("DriveOffDetails.FuelVolume")} />
          <input
            className={Style.textStyleInputEditModal}
            {...register("fuelVolume")}
          />
        </div>

        <div>
          <LabelWithHR label={t("DriveOffDetails.Pillar")} />
          <input
            className={Style.textStyleInputEditModal}
            {...register("pillar")}
          />
        </div>

        <div>
          <LabelWithHR label={t("DriveOffDetails.Amount") + " " + currencyDisplay} />
          <input
            className={Style.textStyleInputEditModal}
            {...register("amount")}
          />
        </div>

        <div>
          <LabelWithHR label={t("DriveOffDetails.ReceiptNumber")} />
          <input
            className={Style.textStyleInputEditModal}
            {...register("billRefNumber")}
          />
        </div>

        <div className={Style.buttonContainer} style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Button
            style={{
              width: "40%",
            }}
            buttonStyle={{
              width: "100%",

            }}
            text={t("Save")}
            type="submit"
          />
        </div>
      </form>
    </Modal>
  );
};

export default DriveOffDetailsModal;